import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,

  Avatar,
  InputAdornment,
  Card,
  CardContent,

} from '@mui/material';

import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';   
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api, UploadFile } from '../webservices';
import Header from './Header'
import Footer from './Footer'

const ContactUs = () => {

  const navigate = useNavigate();

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [number, setNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = {
      fullName,
      email,
      message,
      number,
    };

    const token = localStorage.getItem('token');

    Api('contact/registerContact', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.status === 200) {
          toast.success(Response.data.resmsessage);
          setFullName('')
          setEmail('')
          setMessage('')
          setNumber('')

        } else {
          toast.warn(Response.data.status);
        }
      } else {
        toast.warn('Error!');
      }
    });
  };

  return (
    <>
      <ToastContainer />
      {/* <Stack backgroundColor={'text.secondary'}>
        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          sx={{
            padding: 3,
            mt: 1.5,
            mb: 1.5,
            flexWrap: 'nowrap',
            alignItems: 'center'
          }}
        >
          <Stack flexDirection={'row'} gap={3} >
            <Typography color="white">
              Foxearch Icon
            </Typography>
            <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/home')}>
              Home
            </Typography>
            <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/aboutUs')}>
              About Us
            </Typography>
          </Stack>

          <Stack
            flexDirection="row"
            gap={2}
            sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
          >

            <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
            <Typography color="white" sx={{ cursor: "pointer", marginRight: 4 }} onClick={() => navigate('/login')}>Sign In</Typography>
            <Button
              sx={{
                backgroundColor: "white",
                // color: "transparent", 
                '&:hover': {
                  backgroundColor: "white",
                  // color: "transparent"
                }
              }}
            >
              Request Demo
            </Button>

          </Stack>
        </Stack>
        <Divider sx={{ borderColor: "white" }} />

        <Box
          sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
            py: 8,
            textAlign: 'center'
          }}
        >
          <Container>
            <Typography variant="h2" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="h6">
              We'd love to hear from you! Reach out to us for any inquiries.
            </Typography>
          </Container>
        </Box>
      </Stack>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Get in Touch
        </Typography>
        <Typography variant="body1" paragraph>
          Have any questions or concerns? Feel free to fill out the form below, and we’ll get back to you as soon as possible.
        </Typography>

        <Box component="form" sx={{ mt: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Message"
                multiline
                rows={4}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Button
            variant="contained"
            sx={{ mt: 3, backgroundColor: '#FF6600', '&:hover': { backgroundColor: '#E55D00' } }}
          >
            Submit
          </Button>
        </Box>
      </Container>

      <Stack
        sx={{
          alignItems: 'center',
          py: 5,
          backgroundColor: '#003366',
          color: 'white',
          mt: 5,
        }}
      >
        <Typography variant="h6">
          Address: 123 Main Street, City, Country
        </Typography>
        <Typography variant="h6">
          Email: contact@example.com
        </Typography>
        <Typography variant="h6">
          Phone: +123 456 7890
        </Typography>
      </Stack> */}


      <div id="body" className="page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1277 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled elementor-default elementor-kit-2882 elementor-page elementor-page-1277" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'
      >

        <button id="login_modal_close" aria-controls="login_dropdown" className="nav-btn" aria-expanded="true" aria-label="Login Toggler" />

        {/* </button> */}
        <div id="box" className="box-fade-in">
          <div id="top-wrap">
            <Header />

            <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center nw_tbar">
              <div className="container ">
                <h1 itemProp="headline" style={{ color: '#ed457a' }}>Contact Us</h1>
                <h6 style={{color:'#fff'}}>
                  <small>
                    We're here to help! Whether you have questions, need support, or simply want to learn more about our services, feel free to reach out


                  </small>
                </h6>
                <nav className="breadcrumbs"><span><span><Link to="/home">Home</Link></span> &bull; <span className="breadcrumb_last" aria-current="page">Contact Us</span></span>
                </nav> 
              </div>
            </section>
          </div>

          <section className="text-center cover-center">

            <h5 itemProp="headline" style={{ color: '#3C6BA5', marginTop: '30px', marginBottom: '-30px' }}>Get in Touch</h5>


          </section>

          <div data-elementor-type="wp-page" data-elementor-id="8927" className="elementor elementor-8927">
            <section className="elementor-section elementor-top-section elementor-element elementor-element-5c6c705 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5c6c705" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-2a22ef9" data-id="2a22ef9" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-5d45d05 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5d45d05" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-14765cc" data-id="14765cc" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-1450ccb elementor-view-default elementor-widget elementor-widget-icon" data-id="1450ccb" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024"><path d="M768 0h-512c-53.056 0-96 42.976-96 96v832c0 53.056 42.976 96 96 96h512c52.992 0 96-43.008 96-96v-832c0-53.056-43.008-96-96-96zM800 928c0 17.632-14.368 32-32 32h-512c-17.664 0-32-14.304-32-32v-64.128h576v64.128zM800 831.872h-576v-639.872h576v639.872zM800 160h-576v-64c0-17.664 14.336-32 32-32h512c17.632 0 32 14.336 32 32v64zM576 112c0 8.832-7.2 16-16 16h-96c-8.864 0-16-7.168-16-16v0c0-8.864 7.136-16 16-16h96c8.8 0 16 7.136 16 16v0zM544 911.872c0 8.8-7.2 16-16 16h-32c-8.832 0-16-7.2-16-16v0c0-8.864 7.168-16 16-16h32c8.8 0 16 7.136 16 16v0z" /></svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-a23f2f4 elementor-widget elementor-widget-heading" data-id="a23f2f4" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Call Us</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-ca663ef elementor-widget elementor-widget-text-editor" data-id="ca663ef" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <strong>Phone:</strong> +91 8551842170<br />
                                <strong>Support:</strong> : +1 408 769 4845</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-883733c" data-id="883733c" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-104916a elementor-view-default elementor-widget elementor-widget-icon" data-id="104916a" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024"><path d="M940.64 82.56c-52.64-52.576-121.952-82.56-190.272-82.56-57.632 0-110.688 21.376-149.44 60.064l-155.744 156.928c-0.48 0.448-1.024 0.736-1.504 1.216-0.256 0.256-0.416 0.608-0.672 0.832l0.064 0.064-330.528 333.088c-15.232 15.136-26.272 33.984-32.416 54.56l-75.168 272.256c-0.064 0.736-4.96 22.112-4.96 32.992 0 61.824 50.208 112 112.128 112 12.32 0 36.16-5.888 37.024-6.016l271.296-71.328c20.608-6.112 39.328-17.248 54.56-32.512l488.416-492.256c88.832-88.896 78.816-237.888-22.784-339.328zM512.448 761.44c-2.624-28.864-10.784-57.184-23.008-84.064l302.56-302.528c18.496 58.432 8.992 119.552-31.552 160.128-0.256 0.256-0.576 0.416-0.8 0.672l0.448 0.416-247.296 249.28c0-7.968 0.384-15.776-0.352-23.904zM473.376 648.192c-11.936-19.616-25.504-38.56-42.304-55.328-19.552-19.552-41.984-34.88-65.408-47.744l305.024-305.024c23.936 10.624 46.88 25.76 67.136 46.016 17.312 17.248 30.688 36.576 40.992 56.672l-305.44 305.408zM335.552 529.984c-29.632-11.936-60.672-18.752-91.776-19.168l246.496-248.384c37.728-36.8 92.672-47.392 146.784-33.984l-301.504 301.536zM133.344 955.936c-3.488 0.8-14.336 3.552-21.696 4.064-26.304-0.32-47.648-21.696-47.648-48 0.384-5.376 2.528-14.624 3.264-17.984l33.696-122.048c36.576-0.992 75.936 13.248 106.88 44.256 31.424 31.36 46.208 71.488 44.608 108.512l-119.104 31.2zM283.968 916.384c-0.768-42.944-18.24-87.616-53.504-122.816-33.344-33.376-76.992-52.64-120.512-54.368l31.872-115.424c2.304-7.68 6.88-15.264 12.512-21.888 64.192-45.952 162.912-32.384 231.488 36.256 72.544 72.512 83.744 178.752 27.872 242.176-3.712 1.952-7.456 3.808-11.488 4.992l-118.24 31.072zM918.112 376.704l-53.888 54.304c0-7.232 0.864-14.176 0.192-21.568-5.632-61.92-34.496-121.792-81.376-168.608-52.128-52.16-121.248-82.080-189.696-82.272l52.992-53.44c26.528-26.464 63.552-41.12 104.032-41.12 51.488 0 104.384 23.296 145.056 63.84 38.176 38.112 60.928 85.472 64.192 133.376 3.008 44.704-11.744 85.696-41.504 115.488z" /></svg>			</div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-dec7b08 elementor-widget elementor-widget-heading" data-id="dec7b08" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Write Us</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-faae826 elementor-widget elementor-widget-text-editor" data-id="faae826" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <a href="mailto:example@example.com"><strong>Email : </strong>info@foxearch.com</a><br />
                                <a href="mailto:example@example.com"><strong>Email : </strong> support@foxearch.com</a>						</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e5c0918" data-id="e5c0918" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-b697655 elementor-view-default elementor-widget elementor-widget-icon" data-id="b697655" data-element_type="widget" data-widget_type="icon.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-icon-wrapper">
                                  <div className="elementor-icon elementor-animation-pop">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024"><path d="M512.064 567.872c105.888 0 192-86.144 192-192s-86.112-192-192-192c-105.888 0-192 86.112-192 192s86.112 192 192 192zM512.064 215.872c88.256 0 160 71.744 160 160s-71.744 160-160 160c-88.256 0-160-71.744-160-160s71.744-160 160-160zM512 0c-211.776 0-384 170.112-384 384.032 0 224 192.032 453.152 332.032 614.208 0.512 0.64 22.976 25.76 50.752 25.76 0.064 0 2.336 0 2.464 0 27.744 0 50.24-25.12 50.752-25.76 140.064-161.056 332.064-390.176 332.064-614.208 0-213.92-172.256-384.032-384.064-384.032zM515.744 956.256c-0.672 0.64-2.624 2.048-4.32 3.136-0.32-0.864-2.688-2.752-4.128-4.256-117.28-134.944-315.296-362.688-315.296-571.104 0-176.448 143.584-320.032 320-320.032 176.512 0 320.064 143.584 320.064 320.064 0 208.384-198.016 436.128-316.32 572.192z" /></svg>			</div>
                                </div>
                              </div>
                            </div>
                            <div className="elementor-element elementor-element-5d23ac1 elementor-widget elementor-widget-heading" data-id="5d23ac1" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Visit Us</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-14a5a1f elementor-widget elementor-widget-text-editor" data-id="14a5a1f" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                <strong>USA : </strong>
                                16192 Coastal Hwy,

                                Lewes, DE 19958					</div>
                              <div className="elementor-widget-container">
                                <strong>India : </strong>

                                B 23, B Block, Sector 63,
                                Noida 201301
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div className="elementor-element elementor-element-d049be8 elementor-widget elementor-widget-spacer" data-id="d049be8" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-58a83d5 elementor-widget elementor-widget-shortcode" data-id="58a83d5" data-element_type="widget" data-widget_type="shortcode.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-shortcode">
                          <div className="wpcf7 js" id="wpcf7-f8867-p8927-o1" lang="en-US" dir="ltr">
                            <div className="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true" /></div>
                            <form onSubmit={handleSubmit} className="wpcf7-form init" aria-label="Contact form" noValidate="noValidate">
                              <div style={{ display: 'none' }}>
                                <input type="hidden" name="_wpcf7" value="8867" />
                                <input type="hidden" name="_wpcf7_version" value="5.9.8" />
                                <input type="hidden" name="_wpcf7_locale" value="en_US" />
                                <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f8867-p8927-o1" />
                                <input type="hidden" name="_wpcf7_container_post" value="8927" />
                                <input type="hidden" name="_wpcf7_posted_data_hash" value="" />
                              </div>

                              <div className="layout-gap-20 text-center">
                                <div className="cols-2 grid-wrapper">
                                  <div className="grid-item">
                                    <div className="form-item">
                                      <span className="wpcf7-form-control-wrap" data-name="your-name">
                                        <input
                                          size="40"
                                          maxLength="400"
                                          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control text-center"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Full Name"
                                          value={fullName}
                                          onChange={(e) => setFullName(e.target.value)}
                                          type="text"
                                          name="your-name"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="grid-item">
                                    <div className="form-item">
                                      <span className="wpcf7-form-control-wrap" data-name="your-email">
                                        <input
                                          size="40"
                                          maxLength="400"
                                          className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email form-control text-center"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Email Address"
                                          value={email}
                                          onChange={(e) => setEmail(e.target.value)}
                                          type="email"
                                          name="your-email"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="cols-2 grid-wrapper">
                                  <div className="grid-item">
                                    <div className="form-item">
                                      <span className="wpcf7-form-control-wrap" data-name="your-phone">
                                        <input
                                          size="40"
                                          maxLength="400"
                                          className="wpcf7-form-control wpcf7-tel wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-tel form-control text-center"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Phone Number"
                                          value={number}
                                          onChange={(e) => setNumber(e.target.value)}
                                          type="tel"
                                          name="your-phone"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="grid-item">
                                    <div className="form-item">
                                      <span className="wpcf7-form-control-wrap" data-name="your-topic">
                                        <input
                                          size="40"
                                          maxLength="400"
                                          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control text-center"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Your Message"
                                          value={message}
                                          onChange={(e) => setMessage(e.target.value)}
                                          type="text"
                                          name="your-message"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="mt-30 text-center">
                                  <input
                                    className="wpcf7-form-control wpcf7-submit has-spinner theme_button wide_button color1 large_height"
                                    type="submit"
                                    value="Send Message"
                                  />
                                  <span className="wpcf7-spinner" />
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <div className="text-center ">

              <h5 style={{ color: '#3C6BA5' }}>Business Hours</h5>
              <h6>
                <small>
                  We're available during the following hours:


                </small>
              </h6>
              <ul>
                <li>
                  <strong>
                    Monday - &nbsp;
                  </strong>
                  Friday: 9:00 AM to 6:00 PM (local time)
                </li>

                <li>
                  <strong>
                    Saturday - Sunday - &nbsp;
                  </strong>
                  Closed

                </li>
              </ul>

            </div> */}
            {/* <section className="elementor-section elementor-top-section elementor-element elementor-element-8c0e844 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="8c0e844" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-755c869" data-id="755c869" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-7d16ec0 elementor-widget elementor-widget-google_maps" data-id="7d16ec0" data-element_type="widget" data-widget_type="google_maps.default">
                              <div className="elementor-widget-container">
                                <div className="elementor-custom-embed">
                                  <iframe loading="lazy" src="https://maps.google.com/maps?q=2231%20Sycamore%20Lake%20Road%20Green%20Bay%2C%20WI%2054304&amp;t=m&amp;z=10&amp;output=embed&amp;iwloc=near" title="2231 Sycamore Lake Road Green Bay, WI 54304" aria-label="2231 Sycamore Lake Road Green Bay, WI 54304"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section> */}
            {/* <section className="elementor-section elementor-top-section elementor-element elementor-element-8c0e844 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="8c0e844" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-755c869" data-id="755c869" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">

                    <div className="elementor-element elementor-element-7d16ec0 elementor-widget elementor-widget-google_maps" data-id="7d16ec0" data-element_type="widget" data-widget_type="google_maps.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-custom-embed">
                          <iframe loading="lazy" src="https://maps.google.com/maps?q=38.7736,-75.1425&t=m&z=10&output=embed" title="USA Office: 16192 Coastal Hwy, Lewes, DE 19958" aria-label="USA Office: 16192 Coastal Hwy, Lewes, DE 19958" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

<section className="elementor-section elementor-top-section elementor-element elementor-element-8c0e844 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="8c0e844" data-element_type="section">
  <div className="elementor-container elementor-column-gap-default">
    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-755c869" data-id="755c869" data-element_type="column">
      <div className="elementor-widget-wrap elementor-element-populated">
        <div className="elementor-element elementor-element-7d16ec0 elementor-widget elementor-widget-google_maps" data-id="7d16ec0" data-element_type="widget" data-widget_type="google_maps.default">
          <div className="elementor-widget-container">
            <div className="elementor-custom-embed">
              <iframe 
                loading="lazy" 
                src="https://maps.google.com/maps?q=38.7736,-75.1425&t=m&z=10&output=embed&markers=color:red%7C38.7736,-75.1425%7Ccolor:blue%7C28.5360,77.3926"
                title="USA Office: 16192 Coastal Hwy, Lewes, DE 19958 and India: B 23, B Block, Sector 63, Noida 201301"
                aria-label="USA Office: 16192 Coastal Hwy, Lewes, DE 19958 and India: B 23, B Block, Sector 63, Noida 201301"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


          </div>

          
        </div>
        <Footer />
        <a id="to-top" href="#body">
          <span className="screen-reader-text">
            Go to top		</span>
        </a>

      </div>
    </>
  );
};

export default ContactUs;
